// extracted by mini-css-extract-plugin
export default {"header":"Support_header__j6tRS","supportInfoCard":"Support_supportInfoCard__7XTek","supportCard":"Support_supportCard__PzbiU","title":"Support_title__dWUnj"};